export * from "./MediaText4"
export { default } from "./MediaText4"
